'use strict';

angular.module('menu')
    .controller('MainMenuController', ['AccountManager', function(AccountManager) {
        var vm = this;

        vm.ready = false;

        vm.$onInit = function() {
            return AccountManager.init()
                .then(function() {
                    vm.loggedUser = AccountManager.getLoggedUser();
                    vm.isLogged = AccountManager.isLogged;
                    vm.hasPermission = AccountManager.hasPermission;

                    vm.ready = true;
                });
        };
    }]);
